"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitSymbol = void 0;
exports.InitSymbol = Symbol('InitSymbol');
//# sourceMappingURL=types.js.map